import { BackupAction, BackupActionTypes } from "../types/actions";
import { Backup } from "../types/backup";

const initialState: Backup[] = [];

const backupsReducer = (
    state = initialState,
    action: BackupActionTypes
): Backup[] => {
    switch (action.type) {
        case BackupAction.SET_BACKUPS:
            return action.backups;
        default:
            return state;
    }
};

export default backupsReducer;
